const shared = {
  radii: {
    sm: '8px',
    md: '14px',
    lg: '20px',
    xl: '28px',
    pill: '999px',
  },
  fonts: {
    sans: "'Inter', system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    display: "'Space Grotesk', 'Inter', sans-serif",
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, monospace",
  },
  breakpoints: {
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  layout: {
    maxWidth: '1200px',
  },
};

export const darkTheme = {
  mode: 'dark',
  ...shared,
  colors: {
    bg: '#0B0B12',
    bgSoft: '#111119',
    surface: '#15151F',
    surfaceHi: '#1B1B27',
    border: 'rgba(255,255,255,0.08)',
    borderStrong: 'rgba(255,255,255,0.14)',
    text: '#F5F5F7',
    textDim: '#A7A7B4',
    textMuted: '#6E6E7C',
    primary: '#7C5CFF',
    primarySoft: '#A78BFA',
    accent: '#22D3EE',
    success: '#34D399',
    danger: '#F87171',
    overlay: 'rgba(11,11,18,0.72)',
    modalBackdrop: 'rgba(5, 5, 10, 0.75)',
  },
  shadows: {
    sm: '0 1px 2px rgba(0,0,0,0.4)',
    md: '0 8px 24px rgba(0,0,0,0.35)',
    glow: '0 10px 40px rgba(124, 92, 255, 0.35)',
  },
  ambient: `
    radial-gradient(1000px 600px at 10% -10%, rgba(124,92,255,0.18), transparent 60%),
    radial-gradient(800px 500px at 100% 10%, rgba(34,211,238,0.10), transparent 60%)
  `,
};

export const lightTheme = {
  mode: 'light',
  ...shared,
  colors: {
    bg: '#F7F7FB',
    bgSoft: '#FFFFFF',
    surface: '#FFFFFF',
    surfaceHi: '#F1F1F7',
    border: 'rgba(15,15,25,0.08)',
    borderStrong: 'rgba(15,15,25,0.16)',
    text: '#0F0F1A',
    textDim: '#4A4A5A',
    textMuted: '#6B6B7A',
    primary: '#6947F5',
    primarySoft: '#6947F5',
    accent: '#0891B2',
    success: '#059669',
    danger: '#DC2626',
    overlay: 'rgba(255,255,255,0.75)',
    modalBackdrop: 'rgba(15, 15, 25, 0.45)',
  },
  shadows: {
    sm: '0 1px 2px rgba(15,15,25,0.06)',
    md: '0 10px 30px rgba(15,15,25,0.10)',
    glow: '0 12px 40px rgba(105, 71, 245, 0.30)',
  },
  ambient: `
    radial-gradient(1000px 600px at 10% -10%, rgba(124,92,255,0.14), transparent 60%),
    radial-gradient(800px 500px at 100% 10%, rgba(34,211,238,0.10), transparent 60%)
  `,
};

// Backward-compat named export
export const theme = darkTheme;
